import { useCircleAIShellStore } from "../store/circleAIShellStore";

export const useHasInsetChrome = () => {
  const conversationPanelState = useCircleAIShellStore(
    s => s.conversationPanelState,
  );
  return conversationPanelState !== "closed";
};
